<template>
  <v-container class="col-12">
    <material-card
      class="account-list-table"
      color="green"
    >
      <v-toolbar
        dark
        dense
        color="teal darken-3"
        class="mb-1"
      >
        <v-text-field
          v-model="search"
          clearable
          flat
          solo-inverted
          dense
          hide-details
          prepend-inner-icon="search"
          label="Search"
          @keypress.enter="searchReq"
        />
        <v-btn
          v-on:click="searchReq"
          class="ml-5"
          :disabled="loading"
          :loading="loading"
          text
          :icon="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'"
        >
          <v-icon v-if="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm'">search</v-icon>
          <template v-else>Search</template>
        </v-btn>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        :fixed-header="$vuetify.breakpoint.name !== 'xs' && $vuetify.breakpoint.name !== 'sm' && $vuetify.breakpoint.name !== 'md' "
        :class="{'account-list-mobile' : $vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'md'}"
        :options.sync="options"
        item-key="account_id"
        :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
        :items-per-page="25"
        :server-items-length="pagination.total"
        :height="$vuetify.breakpoint.name == 'xs' || $vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'md' ? null : 'calc(100vh - 170px)'"
      >

        <template v-slot:item.login="{ item, header }">
          <small v-if="item.project">Project: {{ item.project }}<br /></small>
          <a :href="'/user-management/' + item.login " target="_blank">{{ item.login }}</a>
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            v-if="$vuetify.breakpoint.name === 'lg' "
            color="info"
            :href="'/user-management/' + item.login "
            target="_blank"
            small
            :loading="loading"
            :disabled="loading"
            style="white-space: nowrap"
            class="mr-3"
          >
            <v-icon small right dark class="ml-0 mr-2">mdi-account-box-multiple</v-icon>
            Open
          </v-btn>

          <v-btn
            v-if="$store.state.auth.checkAccess({ key: 'change_password', value: true })"
            color="info"
            @click="openPasswordChange(item)"
            small
            :icon="$vuetify.breakpoint.name == 'sm'"
            :loading="loading"
            :disabled="loading"
            style="white-space: nowrap"
            class="mr-3"
          >
            <v-icon dark :class="{'ml-0': $vuetify.breakpoint.name !== 'sm', 'mr-2': $vuetify.breakpoint.name !== 'sm'}">mdi-lock-reset</v-icon>
            <template v-if="$vuetify.breakpoint.name == 'xs' ">Password</template>
            <template v-else-if="$vuetify.breakpoint.name == 'sm'"></template>
            <template v-else>Change Password</template>
          </v-btn>

          <v-btn
            v-if="$store.state.auth.checkAccess({key: 'manual_transaction', value: ['balance', 'refund', 'bonus', 'freespins']})"
            color="info"
            @click="$store.dispatch('manual_transaction/open', item)"
            dark
            :icon="$vuetify.breakpoint.name !== 'xs'"
            small
            :class="{'mt-2': $vuetify.breakpoint.name == 'sm','mb-2': $vuetify.breakpoint.name == 'sm'}"
          >
            <v-icon :class="{'mr-2': $vuetify.breakpoint.name == 'xs'}">monetization_on</v-icon>
            <template v-if="$vuetify.breakpoint.name == 'xs'">MT</template>
          </v-btn>
        </template>
      </v-data-table>
    </material-card>

    <v-dialog v-model="password.modal" max-width="300">
      <v-card v-if="password.modal">
        <v-card-title class="headline">Change Password</v-card-title>
        <v-card-text class="pb-3">
          <v-text-field label="New Password" v-model="password.new" :rules="[v => !!v || 'Password is required', v => v.length >= 6 || 'Password can\'t be less than 6 symbols']"></v-text-field>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn color="warning" outlined @click="password.modal = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined light @click="passwordChange()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <manual-transaction text="" size="icon" :success="searchReq" />
  </v-container>
</template>

<style>
  .account-list-table {
    overflow-x: hidden;
  }

  .account-list-table .v-card__text {
    padding: 0;
  }

  .account-list-mobile .v-data-footer {
    padding-right: 60px !important;
  }

  .account-list-mobile table {
    overflow-x: hidden;
  }

  .account-list-mobile td,
  .account-list-mobile th {
    padding: 0 5px!important;
  }

</style>

<script>
  import { API } from '@/utils/api'
  import { filter } from 'lodash'
  import { mask } from 'vue-the-mask'

  export default {
    directives: {
      mask,
    },
    components: {
      ManualTransaction: () => import('@/components/helper/ManualTransaction'),
    },

    data: () => ({
      baseHeaders: [
        { text: 'Account ID', value: 'account_id', sortable: false },
        { text: 'Login', value: 'login', sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Created', value: 'created', sortable: false },
        { text: 'Balance', value: 'balance', sortable: false },
        { text: 'Bonus', value: 'bonus', sortable: false },
        { text: 'Currency', value: 'currency', sortable: false },
        { text: '#', value: 'action', sortable: false },
      ],
      pagination: {},
      password: {
        modal: false,
        new: '',
        account: false
      },
      options: {},
      items: [],
      search: '',
      loading: false
    }),

    mounted () {
      this.searchReq()
    },

    computed: {
      headers () {

        if (this.$vuetify.breakpoint.name == 'xs' || this.$vuetify.breakpoint.name == 'sm') {
          return filter(this.baseHeaders, (o) => o.value != 'created')
        }

        return this.baseHeaders
      }
    },

    watch: {
      options: {
        handler () {
          this.searchReq()
        },
      }
    },

    methods: {
      searchReq () {
        this.loading = true
        return API.call('/$v/account/search.json', { value: this.search, ...this.options }).then(resp => {
          this.items = resp.data
          this.pagination = resp.pagination
        }).catch(e => {
        }).finally((r) => {
          this.loading = false
        })
      },

      openPasswordChange (account) {
        this.password.modal = true
        this.password.new = ''
        this.password.account = account
      },

      passwordChange () {
        if (this.$store.state.auth.checkAccess({ key: 'change_password', value: true })) {

          if (this.password.new.length < 6) {

            this.$notification.show = true
            this.$notification.message = 'Password can\'t be less than 6 symbols'
            this.$notification.type = 'error'
            return
          }

          API.call('/$v/account/change_password.json', {
            login: this.password.account.login,
            account_id: this.password.account.account_id,
            password: this.password.new
          }, this.password.account).then(resp => {
            this.$notification.show = true
            this.$notification.message = 'Password updated'
            this.$notification.type = 'success'
          }).catch(e => {
            return e
          }).finally(() => {
            this.password.new = ''
            this.password.modal = false
            this.password.account = false
          })
        }
      },

    }

  }
</script>
